export default __webpack_public_path__ + "ecebc9d9985cae19ec4369eb7722220d.svg";